import React, { FC, useState } from "react";
import { Stack } from "@fluentui/react";
import { FixedList } from "cayo.ui";
import { bitLockerColumns } from "@cayo/admin-components/components/grids/constants";
import { ISimpleGrid } from "@cayo/admin-components/components/grids/SimpleGrid";
import { IAdditionalFormProps } from "@cayo/shared/components/Form/types";
import { bitLockerPasswordsForm } from "./bit-locker-passwords-form";
import { defaultBitLockerValues } from "./constants";
import renderForm from "../../../components/Form/renderers";

type TBitLockerPasswordsItem = typeof defaultBitLockerValues;

interface BitLockerPasswordsProps
  extends ISimpleGrid, Pick<IAdditionalFormProps, "intl" | "theme" | "getIconAnnotation"> {
  items: TBitLockerPasswordsItem[];
}

const BitLockerPasswords: FC<BitLockerPasswordsProps> = ({
  name,
  readOnly,
  hidden,
  label,
  items,
  dataTestId,
  disabled,
  intl,
  theme,
  getIconAnnotation,
}) => {
  const [activeItem, setActiveItem] = useState<TBitLockerPasswordsItem>(defaultBitLockerValues);

  const additionalProps: IAdditionalFormProps = {
    model: activeItem,
    setModel: () => {},
    errors: {},
    setErrorCallback: () => {},
    intl,
    theme,
    getIconAnnotation,
  };

  return (
    <Stack>
      <FixedList
        name={name!}
        label={label}
        value={items}
        columns={bitLockerColumns}
        readOnly={readOnly}
        hidden={hidden}
        disabled={disabled}
        dataTestId={dataTestId}
        setValue={() => {}}
        layoutMode="fixedColumns"
        // do not change, must be "single"
        selectionMode="single"
        onSelectedItemsChange={(items) => {
          if (items?.length) {
            setActiveItem(items[0]);
          } else {
            setActiveItem(defaultBitLockerValues);
          }
        }}
      />
      <Stack>{renderForm(bitLockerPasswordsForm, additionalProps)}</Stack>
    </Stack>
  );
};

export default BitLockerPasswords;
